export function contrastRatio(a,b){
 const luminance=hex=>{const channels=hex.replace('#','').match(/.{2}/g).map(v=>parseInt(v,16)/255).map(v=>v<=.04045?v/12.92:((v+.055)/1.055)**2.4);return channels[0]*.2126+channels[1]*.7152+channels[2]*.0722;};
 const x=luminance(a),y=luminance(b);return (Math.max(x,y)+.05)/(Math.min(x,y)+.05);
}
export function buttonVisuals(colors,tone='primary'){
 if(tone==='brand')return {backgroundColor:'#1F5D8F',color:'#FFFFFF',borderColor:'#1F5D8F'};
 if(tone==='danger')return {backgroundColor:colors.critical,color:contrastRatio(colors.critical,'#FFFFFF')>=contrastRatio(colors.critical,'#2A0810')?'#FFFFFF':'#2A0810',borderColor:colors.critical};
 if(tone==='primary')return {backgroundColor:colors.primary,color:colors.primaryInk,borderColor:colors.primary};
 return {backgroundColor:tone==='quiet'?'transparent':colors.surface,color:colors.primary,borderColor:tone==='quiet'?'transparent':colors.primary};
}
